var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { CardButton, DeleteButton, DragHandle, EditButton, EditButtonBackdrop, Overlay, OverlayInnerNew, OverlayWrapper } from './styles';
import { useDispatch } from 'react-redux';
import { toggleLongReadPostUpdate } from '../../../../../actions/toggleLRPostUpdate';
import { deleteLongReadPost } from '../../../../../actions/deleteLongReadPost';
import { getGalllleryUrl } from '../../../../../actions/getGalllleryUrl';
import { FlexBox, HintTooltip, useIsMobile, useToasts } from '@brg/ui';
import useLocalization from '../../../../../hooks/useLocalization';
import useCommonProps from '../../../../../hooks/useCommonProps';
import { EditIcon } from './EditIcon';
import { DeleteIcon } from './DeleteIcon';
import { MoveIcon } from './MoveIcon';
import { CardIcon } from './CardIcon';
import { useModal } from '../../../../../core/modules/modal.module';
import { updateLongReadPost } from '../../../../../actions/updateLongReadPost';
import { addOrChangeAdditionalInfo } from '../../../../../utilites/addOrChangeAdditionalInfo';
import { getLongReadPosts } from '../../../../../actions/getLongReadPosts';
import getAppNameFromAppString from '../../../../../utilites/getAppNameFromAppString';
import { CopyIcon } from './CopyIcon';
import { getIsPayFromPost } from '../../../../../utilites/card/getIsPayFromPost';
import { updateIsPayInCardsInfo } from '../../../../../utilites/card/updateIsPayInCardsInfo';
import { getCardIdsFromPost } from '../../../../../utilites/card/getCardIdsFromPost';
import { MobileEditorActionsTypes } from '../../../../../constants/mobileEditorActions';
import { CARDS_INFO_KEY } from '../../../../../constants/cards';
var EditorOverlayNew = function (_a) {
    var post = _a.post, isShop = _a.isShop, newCardId = _a.cardId, artistId = _a.artistId, dragHandleProps = _a.dragHandleProps, isTextBlock = _a.isTextBlock, withoutDrag = _a.withoutDrag, withoutDelete = _a.withoutDelete, hideCardIcon = _a.hideCardIcon, withoutEdit = _a.withoutEdit, rowIcons = _a.rowIcons, children = _a.children, context = _a.context, onCustomDelete = _a.onCustomDelete;
    var postId = post.postId, userId = post.userId, style = post.style, postCardId = post.cardId;
    var cardIds = getCardIdsFromPost(post);
    var dispatch = useDispatch();
    var t = useLocalization().t;
    var _b = useCommonProps(), longreadId = _b.longreadId, projectId = _b.projectId, appName = _b.appName, sign = _b.sign, bookId = _b.bookId, coverContent = _b.coverContent, typeConnection = _b.typeConnection, onSetMobileEditorAction = _b.onSetMobileEditorAction, toggleMobileEditor = _b.toggleMobileEditor;
    var cardId = newCardId || postCardId;
    var modal = useModal();
    var app = getAppNameFromAppString(appName);
    var isMobile = useIsMobile();
    var toasts = useToasts();
    var handleEditClick = function () {
        dispatch(toggleLongReadPostUpdate(postId, true, longreadId));
        toggleMobileEditor && toggleMobileEditor(true);
        if (isMobile) {
            onSetMobileEditorAction &&
                onSetMobileEditorAction(MobileEditorActionsTypes[post === null || post === void 0 ? void 0 : post.style]);
        }
        if ((coverContent === null || coverContent === void 0 ? void 0 : coverContent.isPresentation) &&
            window.innerWidth <= 992 &&
            coverContent.onLongreadIsReady) {
            coverContent.onLongreadIsReady &&
                coverContent.onLongreadIsReady(Date.now());
        }
    };
    var handleCardClick = function () {
        window.open(getGalllleryUrl(isShop) +
            (context
                ? '/' + (context || '') + '/card/' + cardId
                : '/collection/' + (artistId || userId) + '?card=' + cardId), '_blank');
    };
    var handleCopyClick = function () {
        var link = "".concat(window.location.origin).concat(window.location.pathname, "#").concat(postId);
        var formattedLink = link.replace('edit', 'project');
        navigator.clipboard
            .writeText(formattedLink)
            .then(function () { return toasts.info(t('lms.podcast.link_copied')); });
    };
    var handleAttachCard = function () {
        modal.show('cardSelectMany', {
            cardIds: cardIds || [],
            bookId: bookId,
            isPay: getIsPayFromPost(post),
            onSubmit: function (cardIds, isForPay) {
                modal.hide();
                dispatch(updateLongReadPost('', __assign(__assign({}, post), { cardIds: cardIds, additionalInfo: addOrChangeAdditionalInfo((post === null || post === void 0 ? void 0 : post.additionalInfo) || [], [
                        {
                            name: CARDS_INFO_KEY,
                            value: JSON.stringify(cardIds === null || cardIds === void 0 ? void 0 : cardIds.map(function (cardId) { return ({
                                cardId: cardId,
                                isPay: !!isForPay
                            }); }))
                        },
                        { name: 'projectId', value: projectId }
                    ]) })));
                setTimeout(function () { return dispatch(getLongReadPosts(userId, longreadId, sign)); }, 1000);
            }
        });
    };
    var handleDeleteClick = function () {
        if (!window.confirm(t('confirmation.longread_block_delete')))
            return;
        if (onCustomDelete) {
            onCustomDelete();
            dispatch(deleteLongReadPost(postId, userId, longreadId, sign));
            return;
        }
        dispatch(deleteLongReadPost(postId, userId, longreadId, sign));
    };
    var isEditable = !['video', 'audio'].includes(style);
    var isPostLoading = postId === 'updating' || postId === 'loading';
    var isMobileEditable = post.style === 'image' || post.style === 'normal' || post.style === 'colored' || !isMobile;
    var isAbleToCreateCard = !isMobile &&
        !['card', 'products'].includes(style) &&
        !cardId &&
        !isPostLoading &&
        !['gallllery'].includes(app);
    return (React.createElement(OverlayWrapper, null,
        React.createElement(OverlayInnerNew, { static: isTextBlock },
            !withoutDrag ? (React.createElement(HintTooltip, { customStyle: { background: '#E7E7E7', color: '#70706F' }, h: '40px', w: '40px', text: t('hint.move'), noDisappearDelay: true },
                React.createElement(MoveIcon, __assign({}, dragHandleProps)))) : (React.createElement("div", null)),
            React.createElement("div", { id: "edit-".concat(postId) },
                React.createElement(FlexBox, { direction: 'row', directionMobile: 'row', gx: 8 },
                    isAbleToCreateCard && isEditable && !hideCardIcon && (React.createElement(CardIcon, { onClick: handleAttachCard, text: "".concat(t('edit_buttons.attach_card'), " ").concat((cardIds === null || cardIds === void 0 ? void 0 : cardIds.length) > 0 ? "(".concat(cardIds === null || cardIds === void 0 ? void 0 : cardIds.length, ")") : '') })),
                    !withoutEdit && isEditable && !isPostLoading && isMobileEditable && (React.createElement(HintTooltip, { h: isMobile ? '24px' : '40px', w: isMobile ? '30px' : '48px', closeToRightCorner: true, positionY: 'bottom', noArrow: true, text: t('hint.edit'), noDisappearDelay: true, customStyle: { background: '#E7E7E7', color: '#70706F' } },
                        React.createElement(EditIcon, { onClick: handleEditClick, mobile: isMobile }))),
                    cardId && (React.createElement(HintTooltip, { h: isMobile ? '24px' : '40px', w: isMobile ? '30px' : '48px', closeToRightCorner: true, positionY: 'bottom', noArrow: true, text: t('edit_buttons.open_card'), noDisappearDelay: true, customStyle: { background: '#E7E7E7', color: '#70706F' } },
                        React.createElement(CardIcon, { onClick: handleCardClick }))),
                    !withoutDelete && !isPostLoading && (React.createElement(HintTooltip, { h: isMobile ? '24px' : '40px', w: isMobile ? '30px' : '48px', closeToRightCorner: true, positionY: 'bottom', noArrow: true, text: t('hint.delete'), noDisappearDelay: true, customStyle: { background: '#E7E7E7', color: '#70706F' } },
                        React.createElement(DeleteIcon, { onClick: handleDeleteClick, mobile: isMobile })))))),
        children));
};
export default EditorOverlayNew;
//# sourceMappingURL=EditorOverlayNew.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { CardButton, DeleteButton, DragHandle, EditButton, EditButtonBackdrop, Overlay, OverlayInnerNew, OverlayWrapper } from './styles';
import { useDispatch } from 'react-redux';
import { toggleLongReadPostUpdate } from '../../../../../actions/toggleLRPostUpdate';
import { deleteLongReadPost } from '../../../../../actions/deleteLongReadPost';
import { getGalllleryUrl } from '../../../../../actions/getGalllleryUrl';
import { FlexBox, HintTooltip, useIsMobile, useToasts } from '@brg/ui';
import useLocalization from '../../../../../hooks/useLocalization';
import useCommonProps from '../../../../../hooks/useCommonProps';
import { EditIcon } from './EditIcon';
import { DeleteIcon } from './DeleteIcon';
import { MoveIcon } from './MoveIcon';
import { CardIcon } from './CardIcon';
import { useModal } from '../../../../../core/modules/modal.module';
import { updateLongReadPost } from '../../../../../actions/updateLongReadPost';
import { addOrChangeAdditionalInfo } from '../../../../../utilites/addOrChangeAdditionalInfo';
import { getLongReadPosts } from '../../../../../actions/getLongReadPosts';
import getAppNameFromAppString from '../../../../../utilites/getAppNameFromAppString';
import { CopyIcon } from './CopyIcon';
import { getIsPayFromPost } from '../../../../../utilites/card/getIsPayFromPost';
import { updateIsPayInCardsInfo } from '../../../../../utilites/card/updateIsPayInCardsInfo';
import { getCardIdsFromPost } from '../../../../../utilites/card/getCardIdsFromPost';
import { MobileEditorActionsTypes } from '../../../../../constants/mobileEditorActions';
import { CARDS_INFO_KEY } from '../../../../../constants/cards';
var EditorOverlayNew = function (_a) {
    var post = _a.post, isShop = _a.isShop, newCardId = _a.cardId, artistId = _a.artistId, dragHandleProps = _a.dragHandleProps, isTextBlock = _a.isTextBlock, withoutDrag = _a.withoutDrag, withoutDelete = _a.withoutDelete, hideCardIcon = _a.hideCardIcon, withoutEdit = _a.withoutEdit, rowIcons = _a.rowIcons, children = _a.children, context = _a.context, onCustomDelete = _a.onCustomDelete;
    var postId = post.postId, userId = post.userId, style = post.style, postCardId = post.cardId;
    var cardIds = getCardIdsFromPost(post);
    var dispatch = useDispatch();
    var t = useLocalization().t;
    var _b = useCommonProps(), longreadId = _b.longreadId, projectId = _b.projectId, appName = _b.appName, sign = _b.sign, bookId = _b.bookId, coverContent = _b.coverContent, typeConnection = _b.typeConnection, onSetMobileEditorAction = _b.onSetMobileEditorAction, toggleMobileEditor = _b.toggleMobileEditor;
    var cardId = newCardId || postCardId;
    var modal = useModal();
    var app = getAppNameFromAppString(appName);
    var isMobile = useIsMobile();
    var toasts = useToasts();
    var handleEditClick = function () {
        dispatch(toggleLongReadPostUpdate(postId, true, longreadId));
        toggleMobileEditor && toggleMobileEditor(true);
        if (isMobile) {
            onSetMobileEditorAction &&
                onSetMobileEditorAction(MobileEditorActionsTypes[post === null || post === void 0 ? void 0 : post.style]);
        }
        if ((coverContent === null || coverContent === void 0 ? void 0 : coverContent.isPresentation) &&
            window.innerWidth <= 992 &&
            coverContent.onLongreadIsReady) {
            coverContent.onLongreadIsReady &&
                coverContent.onLongreadIsReady(Date.now());
        }
    };
    var handleCardClick = function () {
        window.open(getGalllleryUrl(isShop) +
            (context
                ? '/' + (context || '') + '/card/' + cardId
                : '/collection/' + (artistId || userId) + '?card=' + cardId), '_blank');
    };
    var handleCopyClick = function () {
        var link = "".concat(window.location.origin).concat(window.location.pathname, "#").concat(postId);
        var formattedLink = link.replace('edit', 'project');
        navigator.clipboard
            .writeText(formattedLink)
            .then(function () { return toasts.info(t('lms.podcast.link_copied')); });
    };
    var handleAttachCard = function () {
        modal.show('cardSelectMany', {
            cardIds: cardIds || [],
            bookId: bookId,
            isPay: getIsPayFromPost(post),
            onSubmit: function (cardIds, isForPay) {
                modal.hide();
                dispatch(updateLongReadPost('', __assign(__assign({}, post), { cardIds: cardIds, additionalInfo: addOrChangeAdditionalInfo((post === null || post === void 0 ? void 0 : post.additionalInfo) || [], [
                        {
                            name: CARDS_INFO_KEY,
                            value: JSON.stringify(cardIds === null || cardIds === void 0 ? void 0 : cardIds.map(function (cardId) { return ({
                                cardId: cardId,
                                isPay: !!isForPay
                            }); }))
                        },
                        { name: 'projectId', value: projectId }
                    ]) })));
                setTimeout(function () { return dispatch(getLongReadPosts(userId, longreadId, sign)); }, 1000);
            }
        });
    };
    var handleDeleteClick = function () {
        if (!window.confirm(t('confirmation.longread_block_delete')))
            return;
        if (onCustomDelete) {
            onCustomDelete();
            dispatch(deleteLongReadPost(postId, userId, longreadId, sign));
            return;
        }
        dispatch(deleteLongReadPost(postId, userId, longreadId, sign));
    };
    var isEditable = !['video', 'audio'].includes(style);
    var isPostLoading = postId === 'updating' || postId === 'loading';
    var isMobileEditable = post.style === 'image' || post.style === 'normal' || post.style === 'colored' || !isMobile;
    var isAbleToCreateCard = !isMobile &&
        !['card', 'products'].includes(style) &&
        !cardId &&
        !isPostLoading &&
        !['gallllery'].includes(app);
    return (React.createElement(OverlayWrapper, null,
        React.createElement(OverlayInnerNew, { static: isTextBlock },
            !withoutDrag ? (React.createElement(HintTooltip, { customStyle: { background: '#E7E7E7', color: '#70706F' }, h: '40px', w: '40px', text: t('hint.move'), noDisappearDelay: true },
                React.createElement(MoveIcon, __assign({}, dragHandleProps)))) : (React.createElement("div", null)),
            React.createElement("div", { id: "edit-".concat(postId) },
                React.createElement(FlexBox, { direction: 'row', directionMobile: 'row', gx: 8 },
                    isAbleToCreateCard && isEditable && !hideCardIcon && (React.createElement(CardIcon, { onClick: handleAttachCard, text: "".concat(t('edit_buttons.attach_card'), " ").concat((cardIds === null || cardIds === void 0 ? void 0 : cardIds.length) > 0 ? "(".concat(cardIds === null || cardIds === void 0 ? void 0 : cardIds.length, ")") : '') })),
                    !withoutEdit && isEditable && !isPostLoading && isMobileEditable && (React.createElement(HintTooltip, { h: isMobile ? '24px' : '40px', w: isMobile ? '30px' : '48px', closeToRightCorner: true, positionY: 'bottom', noArrow: true, text: t('hint.edit'), noDisappearDelay: true, customStyle: { background: '#E7E7E7', color: '#70706F' } },
                        React.createElement(EditIcon, { onClick: handleEditClick, mobile: isMobile }))),
                    cardId && (React.createElement(HintTooltip, { h: isMobile ? '24px' : '40px', w: isMobile ? '30px' : '48px', closeToRightCorner: true, positionY: 'bottom', noArrow: true, text: t('edit_buttons.open_card'), noDisappearDelay: true, customStyle: { background: '#E7E7E7', color: '#70706F' } },
                        React.createElement(CardIcon, { onClick: handleCardClick }))),
                    !withoutDelete && !isPostLoading && (React.createElement(HintTooltip, { h: isMobile ? '24px' : '40px', w: isMobile ? '30px' : '48px', closeToRightCorner: true, positionY: 'bottom', noArrow: true, text: t('hint.delete'), noDisappearDelay: true, customStyle: { background: '#E7E7E7', color: '#70706F' } },
                        React.createElement(DeleteIcon, { onClick: handleDeleteClick, mobile: isMobile })))))),
        children));
};
export default EditorOverlayNew;
//# sourceMappingURL=EditorOverlayNew.js.map